<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <core-table
          title="Accounts"
          :config="config"
          @disa_acc="disaAcc"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.js'
const { put } = require('@/api/base_entity')

export default {
  data () {
    return { config }
  },
  methods: {
    //Issue 176
    async disaAcc(acc) {
      if (this.$can('disa_acc')) //
      {
        const ret = await this.$root.$confirm.open('Confirm LOGIC removal', 'Are you sure to disable this account ?', { color: 'red' })
        if (ret) {
          acc.status = 'Disabled'
          put ('account', acc.id, acc).then( () => {
            this.$root.$emit('openSnackbar', {
              message: 'Account correctly disabled !',
              color: 'green'
            })
          }).catch( (err) => {
            this.$root.$emit('openSnackbar', {
              message: "Disable account Error : " + err.response.data.message,
              color: 'error'
            })
          }).finally( () => {

          })
        }
      }
    }
    //Issue 176
  }
}
</script>
